import { schema } from "normalizr";

const ChartAccountHistorySchema = new schema.Entity("chartAccountHistories");
const ChartAccountHistoryArraySchema = new schema.Array(ChartAccountHistorySchema);

export { ChartAccountHistorySchema, ChartAccountHistoryArraySchema };